import React from 'react';

import Sample from '../sample'

import * as icons from '../icon/icons';
import ButtonAsync from '../button/button-async'
import Button from '../button/button'
import Label from '../label'

//FIXME: create tools class ???
const onSuccess = (e) => new Promise((resolve, reject) => setTimeout(() => resolve(''), 2000))
const onError = (e) => new Promise((resolve, reject) => setTimeout(() => reject(''), 2000));

import './index.styl'
class ButtonSample extends Sample {
    static ID = 0;

    state = {}

    pathI18n = 'sample.app.components.button.'

    constructor(props) {
        super(props)
        this.getTitle = this.getTitle.bind(this)
        this.getBody = this.getBody.bind(this)
    }

    getTitle() {
        return this.pathI18n + 'page.title'
    }

    getBody() {
        let {pathI18n} = this
        let buttonTypes = Object.keys(icons)
        let buttonParams = { onClick:onSuccess, label: pathI18n }

        return <div className="sample-button">
            <ul className="table-list">
                <li className="table-list-row">
                    <div className="table-list-column"><Label>{pathI18n + 'actif'}</Label></div>
                    <div className="table-list-column"><Label>{pathI18n + 'disabled'}</Label></div>
                    <div className="table-list-column"><Label>{pathI18n + 'iconName'}</Label></div>
                </li>
                <li className="table-list-row">
                    <div className="table-list-column">
                        {buttonTypes.map( t => <Button className='table-list-row icon'  key={'bs-enabled' + ButtonSample.ID++} {...buttonParams} icon={t} disabled={false}/>)}
                    </div>
                    <div className="table-list-column">
                        {buttonTypes.map( t => <Button className='table-list-row icon'  key={'bs-enabled' + ButtonSample.ID++} {...buttonParams} icon={t} disabled={true}/>)}
                    </div>
                    <div className="table-list-column">
                        {buttonTypes.map( t => <div className="table-list-row" key={'bs-title' + ButtonSample.ID++}>{ t }</div>)}
                    </div>
                </li>
            </ul>
            <ButtonAsync onClick={onError} label={pathI18n + 'rejected'} labelError={pathI18n+"error"}/>
            <ButtonAsync onClick={onSuccess} label={pathI18n + 'resolve'} />
        </div>
    }
}

export default ButtonSample
